export default __webpack_public_path__ + "static/media/151-trucks-1.a9faebac.png";